import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/site/Header";
import { MobileBar } from "@/components/site/MobileBar";
import { Hero } from "@/components/site/Hero";
import { TrustStrip } from "@/components/site/TrustStrip";
import { Precisou } from "@/components/site/Precisou";
import { Services } from "@/components/site/Services";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Areas } from "@/components/site/Areas";
import { ConversionBand } from "@/components/site/ConversionBand";
import { About } from "@/components/site/About";
import { Reviews } from "@/components/site/Reviews";
import { Gallery } from "@/components/site/Gallery";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  useLenis();
  return (
    <div className="bg-ink text-white overflow-clip">
      <Header />
      <main>
        <Hero />
        <TrustStrip />
        <Precisou />
        <Services />
        <HowItWorks />
        <Areas />
        <ConversionBand />
        <About />
        <Reviews />
        <Gallery />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <MobileBar />
    </div>
  );
}
